import React, { FC, ReactElement, useState, useRef } from 'react';
import styled from 'styled-components';
import { body2 } from '@westwing/ui-kit/typography';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import { AccordionContentWrapper } from '../ContactAndFAQ';
import useElementIntersection from '../../../hooks/useElementIntersection';
import HybridLink from '../../Generic/Links/HybridLink';
import Flag, { sourceByCountryCode } from './Flag';

const Wrapper = styled(AccordionContentWrapper)`
    flex-wrap: wrap;
    height: 169px;
    margin-bottom: 28px;
`;

const CountryRow = styled.div`
    width: 135px;
    margin-bottom: 7px;
    margin-right: 40px;
    display: flex;
    justify-content: space-between;

    ${forDesktop`
        margin-right: 55px;
    `}
`;

const CountryLink = styled(HybridLink)`
    ${body2}
    color: ${({ theme }) => theme.colors.charcoal100};
    width: 104px;
    margin-left: 10px;
`;

const countryLinks: Array<{ link: string; text: string; src: string }> = [
    { link: 'https://www.westwingnow.de/', text: 'westwingnow.de', src: sourceByCountryCode.de },
    { link: 'https://www.westwingnow.ch/', text: 'westwingnow.ch', src: sourceByCountryCode.ch },
    { link: 'https://www.westwingnow.fr/', text: 'westwingnow.fr', src: sourceByCountryCode.fr },
    { link: 'https://www.westwingnow.nl/', text: 'westwingnow.nl', src: sourceByCountryCode.nl },
    { link: 'https://www.westwingnow.pl/', text: 'westwingnow.pl', src: sourceByCountryCode.pl },
    { link: 'https://www.westwingnow.sk/', text: 'westwingnow.sk', src: sourceByCountryCode.sk },
    { link: 'https://www.westwingnow.it/', text: 'westwingnow.it', src: sourceByCountryCode.it },
    { link: 'https://www.westwingnow.es/', text: 'westwingnow.es', src: sourceByCountryCode.es },
    { link: 'https://www.westwingnow.cz/', text: 'westwingnow.cz', src: sourceByCountryCode.cz },
];

const WestwingInternational: FC = (): ReactElement => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [showImages, setShowImages] = useState(false);

    useElementIntersection(wrapperRef, () => {
        setShowImages(true);
    });

    return (
        <Wrapper ref={wrapperRef}>
            {countryLinks.map(country => (
                <CountryRow key={country.text}>
                    <Flag show={showImages} src={country.src} />
                    <CountryLink to={country.link}>{country.text}</CountryLink>
                </CountryRow>
            ))}
        </Wrapper>
    );
};

export default WestwingInternational;
